import styled from "styled-components";

export const Content = styled.div`
  flex-grow: 1;
  padding: 0 16px 0 0;
  position: relative;
  font-family: "Montserrat";
`;
